import { IconProps } from "@tfg/ui"

type Props = IconProps

export const IconLamination = ({ size = 24, ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 29 29"
    fill="none"
    {...props}
  >
    <path d="M20.7217 3.02531V2.00183" stroke="black" strokeLinecap="round" />
    <path d="M20.7217 4.54918V3.5257" stroke="black" strokeLinecap="round" />
    <path
      d="M20.9946 3.27551L22.0181 3.27551"
      stroke="black"
      strokeLinecap="round"
    />
    <path
      d="M19.4707 3.27551L20.4941 3.27551"
      stroke="black"
      strokeLinecap="round"
    />
    <path d="M23.6069 25.0639V23.0169" stroke="black" strokeLinecap="round" />
    <path d="M23.6069 28.1115V26.0646" stroke="black" strokeLinecap="round" />
    <path
      d="M24.153 25.5642L26.2 25.5642"
      stroke="black"
      strokeLinecap="round"
    />
    <path
      d="M21.1052 25.5642L23.1521 25.5642"
      stroke="black"
      strokeLinecap="round"
    />
    <path d="M4.32251 5.59512V3.54816" stroke="black" strokeLinecap="round" />
    <path d="M4.32251 8.64279V6.59583" stroke="black" strokeLinecap="round" />
    <path
      d="M4.86859 6.09546L6.91553 6.09546"
      stroke="black"
      strokeLinecap="round"
    />
    <path
      d="M1.82074 6.09546L3.86768 6.09546"
      stroke="black"
      strokeLinecap="round"
    />
    <path
      d="M5.34242 14.1013C4.29343 13.3853 3.11857 12.8522 1.71181 12.5567C4.12514 8.30163 12.092 8.35735 11.7359 1.34638C19.2058 2.75758 21.2637 11.4305 26.6648 15.0988C26.3265 23.2625 20.1876 21.0266 16.7199 26.3901C15.7981 25.5852 14.9709 24.7751 14.2143 23.9722"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M11.2707 16.7556L14.4308 13.6706C14.7888 13.3211 14.7957 12.7476 14.4462 12.3896L14.3671 12.3085C14.0176 11.9505 13.444 11.9436 13.086 12.2931L9.21899 16.0684C9.14309 16.1424 9.01611 16.0809 9.02728 15.9754L9.14549 14.8591C9.21279 14.2235 8.77458 13.6451 8.14456 13.5378V13.5378C7.49986 13.4281 6.8845 13.8501 6.7546 14.491L5.66826 19.8513C5.53967 20.5571 5.43276 22.1226 6.03394 22.7384C6.11304 22.8194 6.53228 23.2489 7.57642 24.3184C9.00025 25.7769 11.0954 24.6811 11.4195 24.3646L17.7801 18.1551C18.1381 17.8056 18.1411 17.2281 17.7916 16.8701V16.8701C17.4451 16.5152 16.8739 16.5009 16.5147 16.8429L13.8415 19.389L18.3158 15.021C18.664 14.6811 18.6707 14.1233 18.3307 13.7751V13.7751C17.9927 13.4288 17.4388 13.42 17.0898 13.7552L12.5759 18.0925L17.478 13.3068C17.836 12.9573 17.8429 12.3838 17.4934 12.0258L17.4539 11.9853C17.1044 11.6273 16.5308 11.6204 16.1728 11.9699L11.2707 16.7556Z"
      stroke="black"
    />
  </svg>
)
